import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_12W_79_12W_15_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_12w_79_12w_15_99_usd',
		},
		primer: 'prd_zwWXmbRHqA1B',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 84,
		priceMap: {
			USD: 15.99,
		},
		originalPriceMap: {
			USD: 79,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 79,
		},
	},
}
